import { useEffect, useLayoutEffect } from 'react'

// useLayoutEffect logs an SSR warning because it cannot run on the server. For
// effects that only read or mutate the DOM (no-ops on the server anyway), this
// swaps to useEffect when there is no `window`, silencing the warning while
// keeping the synchronous layout pass on the client.
// https://reactjs.org/link/uselayouteffect-ssr
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect

export default useIsomorphicLayoutEffect
